import { useNavigate } from "react-router-dom"
import handleNavigation from "./handleNavigate"
import deleteProject from "../Services/deleteProject"
import { useCallback, useContext, useEffect, useRef, useState } from "react"
import { Button, Dropdown, Modal, RadioButtons } from "@nxtvid/component-library"
import updateProjectTitle from "../Services/updateProjectTitle"
import { fetchRFPData } from "../Pages/RFPBuilder/services/fetchRFPData"
import { UserContext } from "../Contexts/UserContext"
import validateTokens from "../Services/validateTokens"
import { MastheadRefContext } from "../Contexts/MastheadRefContext"
import reduceTokens from "../Services/reduceTokens"

const ListOfStoryboards = ({storyboards, setStoryboards, setStoryboardState, RFPs }) =>{
    let storyboardList = []
    const navigate = useNavigate()
    const edit_icon = require('../Images/edit-icon.png')
    const settings_icon = require('../Images/settings-icon.png')
    const placeholderImage = require('../Images/image_generation_placeholder.jpg')
    const tokenIcon = require('../Images/TokensIcon.png')
    const [projectTitle, setProjectTitle] = useState('')
    const projectTitleRef = useRef(''); 
    const [emptyShotList, setEmptyShotList] = useState(false)
    const [shotListType, setShotlistType] = useState('Empty')
    const [selectedRFP, setSelectedRFP] = useState(null)
    const {userInfo, setUserInfo} = useContext(UserContext)
    const [selectedProject, setSelectedProject] = useState(null)
    const [additionalContext, setAdditionalContext] = useState(null)
    // Modal States
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modalType, setModalType] = useState('confirm')
    const [modalSize, setModalSize] = useState('medium')
    const [modalTitle, setModalTitle] = useState('')
    const [modalDescription, setModalDescription] = useState('' )
    const [modalOnConfirm, setModalOnConfirm] = useState(() => () => {})
    const [modalOnCancel, setModalOnCancel] = useState(() => () => {})
    const [modalConfirmButtonText, setModalConfirmButtonText] = useState('')
    const [modalCancelButtonText, setModalCancelButtonText] = useState('')
    const [modalFormFields, setModalFormFields] = useState([])
    const [modalFunctionParams, setModalFunctionParams] = useState([])
    const [modalChildren, setModalChildren] = useState(null)
    const [modalClassName, setModalClassName] = useState('')
    const { mastheadRef } = useContext(MastheadRefContext)
    const [cursorIndex, setCursorIndex] = useState(0);


    const generateShotListFromPrompt = async (params, context, shotListType) => {
      const [prompt, project, tokenCost] = params

      const additionalContextForPrompt = shotListType === 'RFP' ? context : null
      
      const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
      try {
          const response = await fetch(`${API_BASE_URL}/api/shotlist/translate-prompt`, {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
              },
              body: JSON.stringify({ fields: null, prompt: prompt,  additionalContext: additionalContextForPrompt})
          });
          const result = await response.json();
          if(response.status !== 200){
              setModalType('alert')
              setModalTitle('Error')
              setModalDescription('There was an error generating the shot list. Please try again.')
                setModalConfirmButtonText('OK')
                setModalOnConfirm(()=>()=>setIsModalOpen(false))
                setModalOnCancel(()=>()=>setIsModalOpen(false))
                setModalChildren(null)
                setIsModalOpen(true)
                return
          }
          const tempProjectState = project
          console.log('tempProjectState', tempProjectState)
          console.log(result)
          tempProjectState.shotList = result.shotList
          reduceTokens(tokenCost, userInfo, setUserInfo)
          setStoryboardState(tempProjectState)
          navigate(`/ShotList?projectId=${tempProjectState._id}`)
      } catch (error) {
          console.error('Error generating shot list:', error);
      }
  };
  const startWithEmptyShotList = (project) => {
      setStoryboardState(project)
      navigate(`/ShotList?projectId=${project._id}`)
  }

  useEffect(() => {
    if (!isModalOpen) {
      // Reset modal state when it is closed
      setModalType('confirm');
        setModalSize('medium');
        setModalTitle('');
        setModalDescription('');
        setModalOnConfirm(() => () => {});
        setModalOnCancel(() => () => {});
        setModalConfirmButtonText('');
        setModalCancelButtonText('');
        setModalFormFields([]);
        setModalFunctionParams([]);
        setModalChildren(null);
        setModalClassName('');
        setShotlistType('Empty')
        setSelectedRFP(null)
        setAdditionalContext(null)
        setCursorIndex(0)
    }
  }, [isModalOpen]);
  

  useEffect(() => {
  setModalChildren(() => {
    function ModalContent() {
      // Local state: radios, dropdown, textareas
      const [type, setType] = useState(shotListType || 'Empty');
      const [rfpTitle, setRfpTitle] = useState(selectedRFP || null);
      const [context, setContext] = useState(additionalContext || '');
      const [textPrompt, setTextPrompt] = useState((modalFunctionParams && modalFunctionParams[0]) || '');
      const disabled = !!emptyShotList;

      const onCreate = async () => {
        console.log('onCreate clicked!')
        console.log({ type, rfpTitle, context, textPrompt, selectedProject });
        // mirror local -> parent so your existing handler sees latest values
        setShotlistType(type);
        setSelectedRFP(rfpTitle);
        setAdditionalContext(context);
        setModalFunctionParams([textPrompt, selectedProject]);

        // let state commit before handler reads it
        setTimeout(async () => { await handleCreateShotList(type, [textPrompt, selectedProject], rfpTitle, context); }, 100);
      };
      const rfpOption = (
            <div style={{ width:'100%' }}>
              <div style={{ display:'flex', flexDirection:'row', justifyContent:'flex-start', gap:'1rem' }}>
                <p style={{ margin:0, marginBottom:'.5rem' }}>Generate Shot List from RFP</p>
                <img style={{ height:'2rem', transform:'translateY(-.5rem)' }} src={tokenIcon} alt="" />
                <p style={{ margin:0, marginLeft:'-.5rem' }}>~3</p>
              </div>

              <Dropdown
                key={`dd-${rfpTitle ?? 'none'}`}    // force refresh when selection changes
                dropdownOptions={RFPs.map(r => r.title)}
                border
                placeholder="Select an RFP"
                selected={rfpTitle}                 // LOCAL
                setSelected={setRfpTitle}           // LOCAL
              />

              <textarea
                id="Shot-List-Prompt-RFP"
                placeholder="Additional context to inform the shot list's creation"
                style={{ border:'1px solid #4f59624b', borderRadius:'5px', width:'calc(100% - 1rem)', padding:'.5rem', height:'5rem', fontFamily:'Inter', marginTop:'1rem' }}
                value={context}                      // LOCAL
                onChange={(e) => setContext(e.target.value)}
                disabled={disabled}
                className="ShotList-Prompt"
              />
            </div>
          )

          const textOption = (
            <div>
              <div style={{ display:'flex', flexDirection:'row', justifyContent:'flex-start', gap:'1rem' }}>
                <p style={{ margin:0, marginBottom:'.5rem' }}>Generate Shot List from Text Prompt</p>
                <img style={{ height:'2rem', transform:'translateY(-.5rem)' }} src={tokenIcon} alt="" />
                <p style={{ margin:0, marginLeft:'-.5rem' }}>~1</p>
              </div>

              <textarea
                id="Shot-List-Prompt-Text"
                placeholder="Description of your project to inform the shot list's creation"
                style={{ border:'1px solid #4f59624b', borderRadius:'5px', width:'calc(100% - 1rem)', padding:'.5rem', height:'5rem', fontFamily:'Inter' }}
                value={textPrompt}                   // LOCAL
                onChange={(e) => setTextPrompt(e.target.value)}
                disabled={disabled}
                className="ShotList-Prompt"
              />
            </div>
          )
      return (
        <div style={{ marginTop:'1rem', display:'flex', flexDirection:'column', gap:'1rem', width:'100%' }}>
          {/* Keep labels dumb; render the actual controls below */}
          <RadioButtons
            key={`rb-${type}`}               // force refresh if lib is sticky
            name="shotlist-modal-group"
            selected={type}
            setSelected={setType}            // LOCAL
            radioOptions={[
              { value: 'RFP',        label: rfpOption },
              { value: 'TextPrompt', label: textOption },
              { value: 'Empty',      label: 'Start with Empty Shot List' },
            ]}
          />

          

          

          <Button label="Create Shot List" onClick={async () => {await new Promise((resolve) => onCreate(resolve));}} />
        </div>
      );
    }

    // Return the element ONCE; it keeps its own state while the modal is open
    return <ModalContent />;
  });

  // set once; do NOT depend on typing state
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [selectedRFP, shotListType]);


  const handleCreateShotList = async (shotListType, modalFunctionParams, selectedRFP, additionalContext) => {
    console.log('context:', additionalContext)
    if (shotListType === 'Empty'){
        handleNavigation({path: '/ShotList', navigate: navigate})
    }
    else if (shotListType === 'TextPrompt'){
        if (modalFunctionParams[0] === '' || modalFunctionParams[0] === undefined){
            console.log('No prompt provided')
            return
        }
        else{
            console.log('Generating shot list from prompt:', modalFunctionParams[0])
            const enoughTokens = await validateTokens(1, userInfo)
            if (enoughTokens === false){
                setIsModalOpen(false)
                mastheadRef.current?.triggerTokenModal()
                return
            }
            else if (enoughTokens === null){
                setModalType('alert')
                setModalTitle('Error')
                setModalDescription('There was an error validating your token amount. Please try again.')
                setModalConfirmButtonText('OK')
                setModalOnConfirm(()=>()=>setIsModalOpen(false))
                setModalOnCancel(()=>()=>setIsModalOpen(false))
                setModalChildren(null)
                setIsModalOpen(true)
                return
            }
            const newModalFunctionParams = [...modalFunctionParams, 1]
            await generateShotListFromPrompt(newModalFunctionParams, additionalContext, shotListType)
        }
    }
    else if (shotListType === 'RFP'){
        if (selectedRFP === null){
            console.log('No RFP selected')
            return
        }
        const enoughTokens = await validateTokens(3, userInfo)
            if (enoughTokens === false){
                setIsModalOpen(false)
                mastheadRef.current?.triggerTokenModal()
                return
            }
            else if (enoughTokens === null){
                setModalType('alert')
                setModalTitle('Error')
                setModalDescription('There was an error validating your token amount. Please try again.')
                setModalConfirmButtonText('OK')
                setModalOnConfirm(()=>()=>setIsModalOpen(false))
                setModalOnCancel(()=>()=>setIsModalOpen(false))
                setModalChildren(null)
                setIsModalOpen(true)
                return
            }
        else{
            const selectedRFPId = RFPs.find(rfp => rfp.title === selectedRFP)._id
            const selectedRFPData = await fetchRFPData(userInfo, selectedRFPId)
            const projectObjective = selectedRFPData.rfp.documentData['Project-Objective']
            const targetAudience = selectedRFPData.rfp.documentData['Target-Audience']
            const brandGuidelines = selectedRFPData.rfp.documentData['Brand-Guidelines']
            const videoStyle = selectedRFPData.rfp.documentData['Video-Style']
            const videoLength = selectedRFPData.rfp.documentData['Video-Length']
            const missionStatement = selectedRFPData.rfp.documentData['Mission-Statement']
            const featuredProductsAndServices = selectedRFPData.rfp.documentData['Featured-Products-and-Services']
            const additionalNotes = selectedRFPData.rfp.documentData['Additional-Notes']
            const projectObjectiveString = Array.isArray(projectObjective) ? projectObjective.join(', ') : projectObjective
            const targetAudienceString = Array.isArray(targetAudience) ? targetAudience.join(', ') : targetAudience
            const brandGuidelinesString = Array.isArray(brandGuidelines) ? brandGuidelines.join(', ') : brandGuidelines
            const videoStyleString = Array.isArray(videoStyle) ? videoStyle.join(', ') : videoStyle
            const videoLengthString = Array.isArray(videoLength) ? videoLength.join(', ') : videoLength
            const missionStatementString = Array.isArray(missionStatement) ? missionStatement.join(', ') : missionStatement
            const featuredProductsAndServicesString = Array.isArray(featuredProductsAndServices) ? featuredProductsAndServices.join(', ') : featuredProductsAndServices
            const additionalNotesString = Array.isArray(additionalNotes) ? additionalNotes.join(', ') : additionalNotes
            const prompt = `Project Objective: ${projectObjectiveString}\nTarget Audience: ${targetAudienceString}\nBrand Guidelines: ${brandGuidelinesString}\nVideo Style: ${videoStyleString}\nVideo Length: ${videoLengthString}\nMission Statement: ${missionStatementString}\nFeatured Products and Services: ${featuredProductsAndServicesString}\nAdditional Notes: ${additionalNotesString}`
            await generateShotListFromPrompt([prompt, selectedProject, 3], additionalContext, shotListType)
        }
    }
  }
  
  const handleStartNewShotList = async (project) => {
    setModalClassName('start-new-shotlist-modal')
    setAdditionalContext(null)
      setIsModalOpen(true)
      setModalOnCancel(() => () => setIsModalOpen(false))
      setModalSize('medium')
        setModalConfirmButtonText('Start Shot List')
      setModalType('empty')
        setModalTitle('Start New Shot List')
        setModalDescription(`Choose how you would like to start your new shot list. You can either start with an empty shot list or generate a shot list from a text prompt or an RFP.`)
        
      setModalChildren(
        <div style={{marginTop:'1rem', display:'flex', flexDirection:'column', gap:'1rem'}}>
        <RadioButtons selected ={shotListType} setSelected={setShotlistType} radioOptions={[
    {value:'RFP', label:()=>{
        return (
        <div>
            <div style = {{display:'flex', flexDirection:'row', justifyContent:'flex-start', gap:'1rem'}}><p style={{margin:0, marginBottom:'.5rem'}}>Generate Shot List from RFP</p><img style={{height:'2rem', transform:'translateY(-.5rem)'}} src={tokenIcon}/><p style={{margin:0, marginLeft:'-.5rem'}}>~3</p></div>
            <Dropdown dropdownOptions={RFPs.map(rfp => rfp.title)} border placeholder='Select an RFP' selected={selectedRFP} setSelected={setSelectedRFP}/>
            <textarea placeholder="Additional context to inform the shot list's creation" style={{border:'1px solid #4f59624b', borderRadius:'5px', width:'calc(100% - 1rem)', padding:'.5rem', height:'5rem', fontFamily:'Inter', marginTop:'1rem'}} id="Shot-List-Prompt" value={additionalContext} onChange={(e)=>{setAdditionalContext(e.target.value)}} disabled = {emptyShotList === false ? false : true} className="ShotList-Prompt"/>
        </div>
        )
    }}, {value:'TextPrompt', label: ()=>{return <div>
            <div style = {{display:'flex', flexDirection:'row', justifyContent:'flex-start', gap:'1rem'}}><p style={{margin:0, marginBottom:'.5rem'}}>Generate Shot List from Text Prompt</p><img style={{height:'2rem', transform:'translateY(-.5rem)'}} src={tokenIcon}/><p style={{margin:0, marginLeft:'-.5rem'}}>~1</p></div>
            <textarea placeholder="Description of your project to inform the shot list's creation" style={{border:'1px solid #4f59624b', borderRadius:'5px', width:'calc(100% - 1rem)', padding:'.5rem', height:'5rem', fontFamily:'Inter'}} id="Shot-List-Prompt" value={modalFunctionParams[0]} onChange={(e)=>{setModalFunctionParams([e.target.value, project])}} disabled = {emptyShotList === false ? false : true} className="ShotList-Prompt"/>
        </div>}}, {value:'Empty', label:'Start with Empty Shot List'}]}/>
        <Button label ='Create Shot List' onClick={async()=>await handleCreateShotList(shotListType, modalFunctionParams, selectedRFP, additionalContext)} />
        </div>
        )
  }

      
    
    storyboardList = storyboards.map((storyboard, index) =>{
            if (!storyboard.storyboard) {
                return null; // Skip if storyboard is empty
            }
            const panel1 = storyboard?.storyboard[0] ? storyboard.storyboard[0].image : placeholderImage
            const panel2 = storyboard?.storyboard[1] ? storyboard.storyboard[1].image : placeholderImage
            const panel3 = storyboard?.storyboard[2] ? storyboard.storyboard[2].image : placeholderImage
            return(
            <div className="storyboardCard" id={"storyboard-" + storyboard._id}>
                <div className="storyboardCard-details">
                    <div className="project-title-container">
                        <p className="storyboardCard-name">{storyboard.projectTitle}</p>
                        <div className="settings-container">
                        <img alt="settings icon" className="settings-icon" src={settings_icon}/>
                        <div className="storyboard-settings">
                            <p className="storyboard-setting" onClick={()=>{console.log(`project-id: ${storyboard._id}`); setProjectTitle(storyboard.projectTitle); setIsModalOpen(true); setModalType('form'); setModalTitle('Rename Project'); setModalDescription('Type in the new name of your project'); setModalConfirmButtonText('Update Project Name'); setModalFormFields([{id:`project-title`, field_type:'text',field_placeholder_text:'Project Name'}]); setModalOnCancel(()=>()=>setIsModalOpen(false)); setModalChildren(null); setModalOnConfirm(()=>()=>{updateProjectTitle({newProjectTitle:projectTitleRef.current, projectId:storyboard._id, projects:storyboards, setProjects:setStoryboards}); setIsModalOpen(false)})}}>Edit Project Title</p>
                            <p className="storyboard-setting" onClick={()=>{setModalType('confirm'); setModalTitle('Delete Project'); setModalConfirmButtonText('Delete'); setModalCancelButtonText('Cancel'); setModalOnConfirm(()=>()=>{deleteProject({projectId: storyboard._id, setProjects: setStoryboards}); setIsModalOpen(false)}); setModalOnCancel(()=>()=>setIsModalOpen(false)); setModalDescription('Are you sure you want to delete this project? This action is irreversable.'); setModalChildren(null); setIsModalOpen(true)}}>Delete Project</p>
                            </div>
                        </div>
                    </div>
                    <div className="pre-production-checklist-container">
                    <h4 className="pre-production-checklist-title">Pre-Production Checklist</h4>
                    <div className="pre-production-checklist-item">
                        <p className="edit-shotlist-label" >Shot List:</p>
                        <p className={`storyboard-state-${storyboard.shotListState.replace(' ','-')}`}>{storyboard.shotListState}</p>
                        <img onClick={()=>{if (storyboard.shotListState ==="Not Started"){setStoryboardState(storyboard);setSelectedProject(storyboard);handleStartNewShotList(storyboard)}else{ navigate( `/ShotList?projectId=${storyboard._id}`)}}} className='edit-icon' src={edit_icon} alt="edit icon"/>
                    </div> 
                    <div className="pre-production-checklist-item">
                        <p className="edit-storyboard-label" >Storyboard:</p>
                        <p className={`storyboard-state-${storyboard.storyboardState.replace(' ','-')}`}>{storyboard.storyboardState}</p>
                        <img onClick={()=>{ setStoryboardState(storyboard); navigate(`/Storyboard?projectId=${storyboard._id}`)}} className='edit-icon' src={edit_icon} alt="edit icon"/>
                    </div>   
                    </div>        
                    
                </div>
                <div className="storyboardCard-imgs">
                <img alt="First Storyboard Panel" className="storyboardCard-img index1" src={panel1}/>
                <img alt="Second Storyboard Panel" className="storyboardCard-img index2" src={panel2}/>
                <img alt="Third Storyboard Panel" className="storyboardCard-img index3" src={panel3}/>
                </div>
                
            </div>
            )
               
    })

    const resolvedFields = modalFormFields.map((field) => {
        
        switch (field.id) {
          case `project-title`:
            return {
              ...field,
              field_state: projectTitle,
              field_set_state: (value) => {
                setProjectTitle(value);
                projectTitleRef.current = value;
              },
            };
          default:
            return field;
        }
      });

      
    return (
                <div className="storyboardList">
                {isModalOpen ? <Modal children={modalChildren} type={modalType} onConfirm={()=>modalOnConfirm()} onClose={()=>modalOnCancel()} size={modalSize} title={modalTitle} description={modalDescription} confirm_button_text={modalConfirmButtonText} cancel_button_text={modalCancelButtonText} form_fields={resolvedFields} className={modalClassName}/> : null}
                {storyboardList}
                </div>
              )
}

export default ListOfStoryboards

